import { observer } from 'mobx-react';
import * as React from 'react';
export var Contract = observer(function (props) {
    var plan = props.plan;
    var total = plan.currentPricing.sellInc / 100;
    var discounts = plan.recurringCredits
        ? plan.recurringCredits.reduce(function (acc, discount) {
            return discount.promoCode ? acc + 0 : acc + discount.amount;
        }, 0)
        : 0;
    var totalDiscount = discounts / 100;
    var totalPrice = (total + totalDiscount).toFixed(2);
    var hasActivationFee = plan.currentPricing.customPricings['ContractActivation'] &&
        plan.currentPricing.customPricings['ContractActivation']
            .sellInc !== 0;
    var activationFeeDollarsString = hasActivationFee
        ? (plan.currentPricing.customPricings['ContractActivation']
            .sellInc / 100).toFixed(2)
        : 0.0;
    return (plan.code !== null && (React.createElement("div", { className: "contractInfo" },
        React.createElement("h3", null, plan.name),
        React.createElement("ul", { className: "list-unstyled" },
            React.createElement("li", null, plan.description),
            React.createElement("li", null,
                React.createElement("strong", null,
                    "$",
                    totalPrice,
                    " Charged ",
                    plan.billingInterval)),
            plan.recurringCredits &&
                plan.recurringCredits.map(function (list, index) {
                    return !list.promoCode && (React.createElement("li", { key: index },
                        React.createElement("small", null,
                            "Includes $",
                            Math.abs(list.amount / 100),
                            ' ',
                            list.numberOfCycles > 0 && !list.promoCode
                                ? " for " + list.numberOfCycles + " months (then $" + total.toFixed(2) + ")."
                                : 'per month',
                            ' ',
                            "nbn\u2122 energy bundle discount")));
                }),
            hasActivationFee && (React.createElement("li", null,
                "$", activationFeeDollarsString + " activation fee")),
            React.createElement("li", null,
                React.createElement("a", { href: plan.criticalInformationSummaryUrl, target: "_blank" }, "Critical Information summary")),
            React.createElement("li", null,
                React.createElement("a", { href: "/pdf/acurus-call-rates-international.pdf", target: "_blank" }, "Detailed Call Rates"))))));
});
//# sourceMappingURL=ContractVoip.js.map